import { ConfirmDialog } from "./confirm-dialog";

type ChangeNotificationsAlertProps = {
  onConfirm: () => void;
  onClose: () => void;
  isOpen: boolean;
  isSMS: boolean;
};

export const ChangeNotificationsAlert = ({
  isOpen,
  isSMS,
  onClose,
  onConfirm,
}: ChangeNotificationsAlertProps) => {
  const channel = isSMS ? "SMS" : "email";

  return (
    <ConfirmDialog
      cancelLabel="Keep them on"
      confirmLabel={`Turn off ${channel}`}
      description={`Your clinical team uses ${channel} to send dosing instructions, plan updates and check-in reminders. Turning it off means you may miss them.`}
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={`Turn off ${channel} notifications?`}
      destructive
    />
  );
};
